export const NUTRITION_TELEMETRY_MEAL_TYPES = [
  "breakfast",
  "lunch",
  "dinner",
  "snack",
  "daily",
] as const;

export type NutritionTelemetryMealType = (typeof NUTRITION_TELEMETRY_MEAL_TYPES)[number];

export const NUTRITION_LOG_SOURCES = [
  "manual",
  "food_search",
  "voice",
  "template",
  "copy",
  "unknown",
] as const;

export type NutritionLogSource = (typeof NUTRITION_LOG_SOURCES)[number];

export const WEIGHT_LOG_SOURCES = [
  "weight_tracker",
  "daily_routine",
  "unknown",
] as const;

export type WeightLogSource = (typeof WEIGHT_LOG_SOURCES)[number];

export const MEASUREMENTS_LOG_SOURCES = [
  "measurements",
  "daily_routine",
] as const;

export type MeasurementsLogSource = (typeof MEASUREMENTS_LOG_SOURCES)[number];

export const MEASUREMENTS_TAB_VIEW_SOURCES = [
  "navigation",
  "daily_routine",
  "direct",
] as const;

export type MeasurementsTabViewSource = (typeof MEASUREMENTS_TAB_VIEW_SOURCES)[number];

export const PHOTO_UPLOAD_SOURCES = [
  "gallery",
  "daily_routine",
] as const;

export type PhotoUploadSource = (typeof PHOTO_UPLOAD_SOURCES)[number];

export const COMPARISON_CREATED_SOURCES = ["gallery"] as const;

export type ComparisonCreatedSource = (typeof COMPARISON_CREATED_SOURCES)[number];

export const VIDEO_UPLOAD_SOURCES = [
  "gallery",
  "daily_routine",
  "workout",
] as const;

export type VideoUploadSource = (typeof VIDEO_UPLOAD_SOURCES)[number];
